/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

type ProjectResponse = {
	readonly id: string;
};

export const projectIdResource: RouteResource<ProjectResponse> = createResource<ProjectResponse>({
	type: 'PROJECT_ID',
	getKey: (routerContext) => {
		const projectKey = routerContext.match.params.projectKey;
		return `project-id-${projectKey}`;
	},
	getData: async (routerContext) => {
		const projectKey = routerContext.match.params.projectKey;
		if (!projectKey) {
			throw new Error('Project key is required');
		}

		const project = await performGetRequest(`/rest/api/2/project/${projectKey}`);
		return project;
	},
	maxAge: 1000 * 60 * 60, // 1 hour cache since project IDs don't change often
});
